/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { get, find } from 'lodash';

/**
 * Internal dependencies
 */
import Card from 'components/card';
import { requestRetailerPlansIfNotRequested } from 'state/rental-plans/actions';
import { getAllRetailerRentalPlans, requestingRetailerRentalPlans } from 'state/rental-plans/selectors';
import { swapSubscription } from 'state/subscriptions/actions';
import { 
    getCurrentRetailerRentalId, 
    getCurrentRetailerRentalPlanId, 
    getCurrentRetailerRental, 
    requestingCurrentRetailerRental,
    hasScheduledChanges } from 'state/current-retailer-rental/selectors';
import { 
    requestCurrentRetailerRentalIfNotRequested, 
    requestCurrentRetailerRental } from 'state/current-retailer-rental/actions';
import { successNotice } from 'state/notices/actions';
import { requestAddonsIfNotRequested } from 'state/addons/actions';

import { getAllAddons } from 'state/addons/selectors';
import Plan from './plan';
import DropdownSelect from 'components/dropdown-select';
import Preloader from 'components/preloader';
import cscom from 'lib/customer-site-api';
import cb from 'lib/chargebee';
import Money from 'components/money';
import ButtonGroup from 'components/button-group';
import Button from 'components/button';
import Icon from 'components/icon';
import { getCurrentUser } from 'state/current-user/selectors';
import { requestCouponsIfNotRequested } from 'state/coupons/actions';
import { Box, Text, Stack } from '@towersystems/towersystems-design-system';
import FlashMessage from 'components/flash-message';
import page from 'page';
import ConfirmNewPlanAlert from './confirm-new-plan-alert'; // Import

/**
 * Style dependencies
 */
import './styles.scss';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

const SelectPlan = (props) => {
    const retailerRentalPlans = props.retailerRentalPlans;
    const [submitting, setSubmitting] = useState(false);
    const [values, setValues] = useState({});


    const resolveLicenseAddon = (plan) => {
        return null;
    };

    const handleSubmitSelectPlan = (value) => {
        setSubmitting(false);
        confirmAlert({
			title: 'Remove Scheduled Changes',
			message: 'Are you sure to do this.',
			closeOnEscape: false,
			closeOnClickOutside: false,
            customUI: ({ onClose }) => (
                <ConfirmNewPlanAlert
                    onClose={onClose}
                    //onSubmit={() => handleSubmit(value)}
                />
            ),
		});
    };

    const handleSubmit = (value) => {
        setSubmitting(true);
        return props
          
            .then((s) =>
                props.successNotice(
                    'Your support subscription will be updated at the end of the current billing period.',
                ),
            )
            .then(() => props.afterSuccess && props.afterSuccess())
            .finally(() => setSubmitting(false));
    };

    if (props.requesting) {
        //return <Loader />;
    }

    return (

            <Box marginTop='large'>
                <Button primary onClick={handleSubmitSelectPlan} >
                    <Box display='flex' alignItems='center'>
                        <Box paddingRight='large' display='flex' alignItems='center'>
                            <Icon type='fi' name='FiPlus' />
                        </Box>
                        <Text>Subscribe to a plan</Text>
                    </Box>
                </Button>
            </Box>

    );
};

export default connect(
    (state) => ({
        retailerRentalPlans: getAllRetailerRentalPlans(state),
        addons: getAllAddons(state),
        //retailerRentalSubscriptionId: getCurrentRetailerRentalId(state),
        retailerRentalSubscriptionId: getCurrentRetailerRentalId(state),
        retailerRentalPlanId: getCurrentRetailerRentalPlanId(state),
        currentRetailerRental: getCurrentRetailerRental(state),
        currentUser: getCurrentUser(state),
        requesting: requestingCurrentRetailerRental(state),
        hasScheduledChanges: hasScheduledChanges(state),
    }),
    {
        requestRetailerRentalPlans: requestRetailerPlansIfNotRequested,
        requestCoupons: requestCouponsIfNotRequested,
        swapSubscription,
        successNotice,
        requestAddons: requestAddonsIfNotRequested,
        requestCurrentRetailerRental: requestCurrentRetailerRentalIfNotRequested,
    },
)(SelectPlan);
